import { FurnishedMarketAPI_Data } from '@sales-app/api/DisplayCity/DisplayCity'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { Favorite } from '@sales-app/graphql/queries/potentialBooking/favorite.queries'
import { PinnedHome } from '@sales-app/graphql/queries/potentialBooking/pinnedHomes.queries'
import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import { BaseHome } from '@sales-app/types/Home'
import { getPricingFields } from '@sales-app/views/PotentialBooking/PotentialBooking/ActivitySection/RecommendedHomes/RecommendedHomes.data'

export function getHomesFromFavoritesPinned(
  favorites: Favorite[],
  pinned: PinnedHome[],
  potentialBookingId?: number | null,
) {
  const cityHomeMap = {}
  const homes: PinFavHome[] = []
  favorites.forEach((f) => {
    const { displayCitySlug, homeId } = f
    if (displayCitySlug) {
      if (cityHomeMap[displayCitySlug]) {
        cityHomeMap[displayCitySlug].push(homeId)
      } else {
        cityHomeMap[displayCitySlug] = [homeId]
      }
      const index = homes.findIndex((h) => h.homeId === f.homeId)
      if (index < 0) {
        homes.push({
          favorite: true,
          favoriteId: f.id,
          pinned: false,
          potentialBookingId: potentialBookingId ? potentialBookingId : null,
          displayCityId: null,
          ...f,
        })
      }
    }
  })

  pinned.forEach((p) => {
    const { displayCity, homeId } = p
    const { slug: displayCitySlug, id } = displayCity || {}
    if (displayCitySlug && id) {
      if (cityHomeMap[displayCitySlug]) {
        cityHomeMap[displayCitySlug].push(homeId)
      } else {
        cityHomeMap[displayCitySlug] = [homeId]
      }
      const index = homes.findIndex((h) => h.homeId === p.homeId)
      if (index < 0) {
        homes.push({
          ...p,
          favorite: false,
          pinned: true,
          potentialBookingId: potentialBookingId ? potentialBookingId : null,
          pinnedId: p.id,
          displayCityId: id,
          displayCitySlug,
        })
      } else {
        homes[index].pinned = true
        homes[index].pinnedId = p.id
        homes[index].displayCityId = id
        homes[index].displayCitySlug = displayCitySlug
      }
    }
  })

  return {
    homes,
    cityHomeMap,
  }
}

export function getFavoritesPinnedData(
  mcHomes: PinFavHome[],
  displayCityData: FurnishedMarketAPI_Data,
  bookablePerson?: WorkspaceTab,
) {
  const { homes: displayCityHomes = [], display_city } = displayCityData
  const homes: RecommendedHomeRow[] = []
  const { bookablePersonId, bookablePersonType, userId } = bookablePerson || {}
  displayCityHomes.forEach((d) => {
    const index = mcHomes.findIndex((h) => h.homeId === d.id)
    if (index >= 0) {
      const mcHome = mcHomes[index]
      const { pinnedId, favoriteId, displayCityId } = mcHome
      const pricingFields = getPricingFields(d)
      if (mcHome) {
        homes.push({
          favorite: mcHome.favorite,
          pinned: mcHome.pinned,
          potentialBookingId: mcHome.potentialBookingId,
          pinnedId,
          favoriteId,
          ...pricingFields,
          ...d,
          bookablePersonId,
          bookablePersonType,
          userId: userId ? userId : undefined,
          displayCityId: displayCityId ? displayCityId : undefined,
          displayCityName: display_city?.name,
        })
      }
    }
  })
  return homes
}

export interface PinFavHome {
  baths: number
  bedrooms: number | null
  displayCityId: number | null
  displayCitySlug: string | null
  favorite: boolean
  favoriteId?: number
  homeId: number
  id: number
  pinned: boolean
  pinnedId?: number
  potentialBookingId: number | null
  squareFootage: number | null
  state: string | null
  unitName: string | null
}

export interface RecommendedHomeRow extends BaseHome {
  bedBath: string
  bookablePersonId?: number
  bookablePersonType?: BookablePersonType
  displayCityId?: number
  displayCityName?: string
  displayPrice: number
  displayPriceWithoutDiscount?: number
  durationText: string
  earliestAvailable: string
  favorite: boolean
  favoriteId?: number
  homeImage: string
  isSpecialOffer: boolean
  offerExpiration?: string | null
  pinned: boolean
  pinnedId?: number
  potentialBookingId: number | null
  priceTooltip?: string
  start_date_or_first_available_start_date?: string
  userId?: number
}
